import { MouseEvent } from "react";

const GraphyArrow = ({
  className,
  onClick,
}: {
  className?: string;
  onClick?: (e: MouseEvent<SVGSVGElement>) => void;
}) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <path
        d="M9.5791 17.9775L26.4206 17.9775"
        stroke="#3A3D50"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M17.0315 24.5454C17.0315 24.5454 18.9115 17.9221 26.4208 17.9221C18.9007 17.9221 17.0315 11.2988 17.0315 11.2988"
        stroke="#3A3D50"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default GraphyArrow;
